var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog-title-with-hint"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"hint"},[_vm._v(_vm._s(_vm.hint))])])
}
var staticRenderFns = []

export { render, staticRenderFns }